export enum Module {
  RESERVATION = 'reservations',
  RESERVATION_CANVAS = 'reservations.canvas',
  RESERVATION_TABLE = 'reservations.table',
  RESERVATION_SERVICE_OBJECT_KINDS = 'reservations.minuteObjectKindTypes',

  GUESTS_GRID = 'guests.database',
  COMPANIES_GRID = 'guests.partners.database',
  COMPANIES_AGENCY_SETTINGS = 'guests.partners.pairing',
  COMPANIES_AGENCY_TAB = 'guests.partners.companySystem',
  CONTACT_PERSONS_GRID = 'guests.contactPersons',
  FOREIGN_GUEST_REGISTER = 'guests.foreignGuestRegister',
  GUEST_BOOK = 'guests.guestBook',
  MAILING = 'guests.mailing',
  OTA_COMMUNICATION = 'guests.otaCommunication',
  BENEFIT_PROGRAM_CARDS = 'guests.benefitProgram.cards',
  BENEFIT_PROGRAM_POINTS_ON_CARD = 'guests.benefitProgram.modulePointsOnCard',

  PAYMENTS_GRID = 'cashDesk.payments',
  PAYMENTS_BANKTRANSFERS_GRID = 'cashDesk.payments.bankTransfers',
  PAYMENTS_COUPONS_GRID = 'cashDesk.payments.coupons',
  PAYMENTS_CASHBOOK_GRID = 'cashDesk.payments.cashBook',
  PAYMENTS_ONLINE_GRID = 'cashDesk.payments.online',
  PAYMENTS_TERMINAL_GRID = 'cashDesk.payments.terminal',
  PAYMENTS_INVOICING = 'cashDesk.invoicing',
  PAYMENTS_FISCALIZATION = 'cashDesk.fiscalization',
  PAYMENTS_GIFT_VOUCHERS = 'cashDesk.giftVouchers',
  PAYMENTS_FOLIO = 'cashDesk.folio',
  PAYMENTS_STOCK_RETAIL_SALES = 'cashDesk.stock.retailSales',
  PAYMENTS_BALANCE = 'cashDesk.balance',
  PAYMENTS_EXCHANGE_OFFICE = 'cashDesk.exchangeOffice',
  PAYMENTS_ACCOUNT_ASSIGNMENT = 'cashDesk.invoiceLists.accountAssignment',
  PAYMENTS_VAT_BREAKDOWN = 'cashDesk.invoiceLists.vatBreakdown',
  PAYMENTS_PL_SERVICE_CLASSIFICATION = 'cashDesk.invoiceLists.polishServiceClassification',
  PAYMENTS_PL_GTU_CODES = 'cashDesk.invoiceLists.polishGtuCodes',
  PAYMENTS_STOCK_ITEMS = 'cashDesk.stock.stockItems',

  REPORTS_USER_LOG = 'reports.userLog',
  REPORTS_FOR_STAT_AUTH = 'reports.reportsForStatAuthorities',
  REPORTS_DAILY_OVERVIEW = 'reports.dailyOverview',
  REPORTS_TAX_REPORT = 'reports.taxReport',
  REPORTS_GUEST_REVIEWS = 'reports.guestReviews',
  REPORTS_BONUSES = 'reports.bonuses',
  REPORTS_NTAK_REPORT = 'reports.ntakReport',
  REPORTS_DASHBOARD = 'reports.managerReports.dashboard',
  REPORTS_ALFRED_DASHBOARD = 'reports.managerReports.alfredDashboard',
  REPORTS_OCCUPANCY = 'reports.managerReports.occupancy',
  REPORTS_RESERVATION = 'reports.managerReports.reservation',
  REPORTS_PICKUP = 'reports.managerReports.pickup',
  REPORTS_FINANCE = 'reports.managerReports.finance',
  REPORTS_OVERVIEW = 'reports.managerReports.overview',

  PRICES = 'prices.prices',
  PRICES_MEALS = 'prices.meals',
  PRICES_REVENUE_MANAGEMENT = 'prices.discountsSurcharges.revenueManagement',
  PRICES_CURRENCIES_EXCHANGE_RATES = 'prices.currenciesExchangeRates',
  PRICES_TAX_SETTINGS = 'prices.taxSettings',
  PRICES_LONG_TERM_STAY = 'prices.discountsSurcharges.longTermStay',
  PRICES_FIRST_MINUTE = 'prices.discountsSurcharges.firstMinute',
  PRICES_LAST_MINUTE = 'prices.discountsSurcharges.lastMinute',
  PRICES_ACTION_PRICE = 'prices.discountsSurcharges.actionPrice',
  PRICES_DISCOUNT_COUPONS = 'prices.discountsSurcharges.discountCoupons',
  PRICES_SERVICES = 'prices.services',
  PRICES_STAY_PACKAGES = 'prices.stayPackages',

  OFFERS_GRID = 'offers',
  HOUSEKEEPING_DEFECT_GRID = 'housekeeping.faults',
  HOUSEKEEPING_CLEANING_GRID = 'housekeeping.cleaning',
  HOUSEKEEPING_TASK_GRID = 'housekeeping.traces',

  SETTINGS_HOTEL_GENERAL = 'settings.hotel.general',
  SETTINGS_HOTEL_AMENITIES = 'settings.hotel.amenities',
  SETTINGS_HOTEL_PHOTOGALLERIES = 'settings.hotel.photogalleries',
  SETTINGS_HOTEL_GUEST_CATEGORIES = 'settings.hotel.guestCategories',
  SETTINGS_HOTEL_ROOMS = 'settings.hotel.rooms',
  SETTINGS_HOTEL_CONNECTORS = 'settings.hotel.connectors',

  ONLINE_RESERVATION_BOOKING = 'settings.onlineReservation.common',
  SETTINGS_ONLINE_RESERVATION_PAYMENTS = 'settings.onlineReservation.payments',
  SETTINGS_ONLINE_RESERVATION_TERMS_AND_CONDITIONS = 'settings.onlineReservation.termsAndConditions',
  SETTINGS_ONLINE_RESERVATION_PREVIO_PARTNERS = 'settings.onlineReservation.previoPartners',

  SETTINGS_WEB_GENERAL = 'settings.web.general',
  SETTINGS_WEB_WEBSECTIONS = 'settings.web.webSections',
  SETTINGS_WEB_NEWS = 'settings.web.news',
  SETTINGS_WEB_UPDATE_WP_DATA = 'settings.web.updateWpData',
  SETTINGS_WEB_LOGIN_WP_ADMIN = 'settings.web.loginWpAdmin',

  SETTINGS_ALFRED_APP = 'settings.alfredApp',
  SETTINGS_SELF_SERVICE_BAR = 'settings.selfServiceBar',
  SETTINGS_POS = 'settings.pos',

  SETTINGS_LOCK_SYSTEMS = 'settings.lockSystems',
  SETTINGS_LOCK_SYSTEMS_SETUP = 'settings.lockSystems.setup',

  SETTINGS_USERS_ROLES = 'settings.users.roles',
  SETTINGS_USERS_USER_LIST = 'settings.users.userList',

  SETTINGS_TRANSLATIONS = 'settings.translations',
  SETTINGS_MARKET_CODES = 'settings.marketCodes',
  SETTINGS_IMPORTANT_DAYS = 'settings.importantDays',

  SETTINGS_SYSTEM = 'settings.system',
  SETTINGS_EMAIL_SETTINGS = 'settings.emailSettings',

  HELP_INVOICES = 'help.invoices',
  HELP_USER_TIPS = 'help.userTips',
  HELP = 'help',
}
